/**
 * Created by administrato on 2017/7/7.
 */
/* eslint-disable */
var routerPrefix = '';
var version = '/'; // 打包的版本号，一定要注意修改
// 劳务微店
var labRouterPrefix = '';
var labVersion = '/';
// task
var taskRouterPrefix = '';
var taskVersion = '/';

if (process.env.NODE_ENV && process.env.NODE_ENV !== 'development') {
  routerPrefix = '/msg';
  version = '/v4/'; // 打包的版本号，一定要注意修改
  labRouterPrefix = '/rwb';
  labVersion = '/v4/';
  taskRouterPrefix = '/m';
  taskVersion = '/v4/';
}
module.exports = {
  version: version, // 打包的版本号，一定要注意修改
  routerPrefix: routerPrefix,
  baseVersionRouter: routerPrefix + version, // 有版本
  baseRouter: routerPrefix + '/', // 没有版本和熱加載用的
  // 劳务微店
  labRouterPrefix: labRouterPrefix,
  labBaseVersionRouter: labRouterPrefix + labVersion, // 有版本
  labBaseRouter: labRouterPrefix + '/', // 没有版本和熱加載用的
  // task项目
  taskRouterPrefix: taskRouterPrefix,
  taskBaseVersionRouter: taskRouterPrefix + taskVersion, // 有版本
  taskBaseRouter: taskRouterPrefix + '/', // 没有版本和熱加載用的
};



//////////////////
// WEBPACK FOOTER
// ./config/router.env.js
// module id = 192
// module chunks = 0 1 2 3 4 5 6 7 8